import React from "react";
import { Animate } from "react-move";
import { ThemeConsumer } from "styled-components";

import { Opinion } from "@/service/Model";
import { easeBounceOut } from "@/utils/animation";

import {
  bucketWidth,
  centerPoint,
  isEnded,
  Result,
  spaceBetweenBucketsOffset,
  totalWidth,
} from "../MeterConstants";

export type MeterResultsProps = {
  hasVoted: boolean;
  results: Result[];
  meter: Opinion;
};

const MeterResults: React.FC<MeterResultsProps> = ({
  hasVoted,
  results,
  meter,
}) => {
  const renderBars = (result: Result, theme: ITheme, index: number) => (
    <Animate
      key={index}
      start={{
        height: result.size,
        background:
          result.percent === 0 ? theme.colors.borderGrey : theme.colors.primary,
        opacity: result.percent === 0 ? 0.75 : result.opacity,
        percent: result.percent,
      }}
      update={{
        height: [result.size],
        background: [
          result.percent === 0 ? theme.colors.borderGrey : theme.colors.primary,
        ],
        opacity: [result.percent === 0 ? 0.75 : result.opacity],
        percent: [result.percent],
        timing: {
          duration: 300,
          ease: easeBounceOut,
        },
      }}
    >
      {(animation: {
        height: number;
        background: string;
        opacity: number;
        percent: number;
      }) => (
        <g
          transform={`translate(${
            result.bucket - bucketWidth / 2
          }, ${centerPoint.y - animation.height})`}
          key={index}
        >
          <text
            transform={`translate(${bucketWidth / 2}, -10)`}
            textAnchor="middle"
            className="meterResultText"
            fill="#000"
            height={40}
          >
            {Math.round(animation.percent)}%
          </text>
          <rect
            x={spaceBetweenBucketsOffset / 2}
            y={0}
            width={bucketWidth - spaceBetweenBucketsOffset}
            height={animation.height}
            fill={animation.background}
            style={{ opacity: animation.opacity }}
          />
        </g>
      )}
    </Animate>
  );

  return (
    <ThemeConsumer>
      {(theme: ITheme) => (
        <g>
          <rect
            x={0}
            y={centerPoint.y}
            width={totalWidth}
            height={2}
            fill="#dedede"
          />
          {(isEnded(meter) || hasVoted) &&
            results.map((result, index) => renderBars(result, theme, index))}
        </g>
      )}
    </ThemeConsumer>
  );
};

export default MeterResults;
